import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SpeechComponent } from "./speech.component";

@NgModule({
	declarations: [SpeechComponent],
	imports: [CommonModule],
	exports: [SpeechComponent]
})
export class SpeechModule {}
